import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { RootState, useAppDispatch, useAppSelector } from '../../../redux';
import { loadSetting, updateSetting } from '../../../redux';
import { Ability } from '../../../components';
import SettingForm from '../SettingForm/SettingForm';

function SettingEdit() {
    const { t }    = useTranslation();
    const dispatch = useAppDispatch();
    let { id }     = useParams();

    const { setting } = useAppSelector((state: RootState) => state.settings);

    useEffect(() => {
        if (id)
            dispatch(loadSetting(id));
    }, [dispatch, id]);

    const submit = function (values: AnyObj) : void {
        dispatch(updateSetting(values));
    }

    return (
        <Ability can="setting:edit" redirect="/settings">
            <div className="SettingEdit">
                <header className="bg-white dark:bg-gray-800 border-b dark:border-gray-700 px-4 py-0 sm:px-6 lg:px-8">
                    <div className="my-2 mx-auto lg:flex lg:items-center lg:justify-between">
                        <div>
                            <h2 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-100">
                                { t('settings.edit_setting', {name: setting?.name}) }
                            </h2>
                        </div>
                    </div>
                </header>
                <main className="mx-6 my-6 shadow">
                    {setting && (setting._id === id) && (
                        <SettingForm isCreation={false} initialValues={setting} onSubmit={submit} />
                    )}
                </main>
            </div>
        </Ability>
    );
}

export default SettingEdit;
